import { log } from '../../utils/logger'
import { type PilarData } from './irsData'

// export type CurvePoint = { T: number; S: number } // T en años, S tipo par

function newtonSolve(f: (x: number) => number, x0: number, maxIter = 50, tol = 1e-14): number {
    let x = x0
    for (let k = 0; k < maxIter; k++) {
        const h = 1e-12
        const fx = f(x)
        const dfx = (f(x + h) - fx) / h
        const step = fx / dfx
        x -= step
        if (Math.abs(step) < tol) {
            // log.info('iterations k:', k)
            break
        }
    }
    return x
}

function logLinearDF(t: number, T1: number, T2: number, DF: Map<number, number>): number {
    const df1 = DF.get(T1)!
    const df2 = DF.get(T2)!
    const w = (t - T1) / (T2 - T1)
    const lnDF = Math.log(df1) + w * (Math.log(df2) - Math.log(df1))
    return Math.exp(lnDF)
}

export function bootstrapCurve(irsData: PilarData[], periodIndex: number): Map<number, number> {
    const dc = new Map<number, number>()
    // sort by tenor T
    irsData = [...irsData].sort((a, b) => a.tenor - b.tenor)

    dc.set(0, 1)
    for (let idx = 0; idx < irsData.length; idx++) {
        const { tenor, valores } = irsData[idx]
        // const rt = valores[0] / 100 // first value is most recent
        const rt = valores[periodIndex] / 100
        // log.info('rt:', rt)

        // first pillar
        if (tenor === 1) {
            dc.set(1, 1 / (1 + rt))
            continue
        }

        // sum all preceding DF's
        let sumKnown = 0
        for (let i = 1; i < tenor; i++) {
            if (dc.has(i)) sumKnown += dc.get(i)!
        }

        // pillars up until T=5
        if (tenor <= 5) {
            const dfT = (1 - rt * sumKnown) / (1 + rt)
            dc.set(tenor, dfT)
            continue
        }

        //
        const prevT = irsData[idx - 1].tenor

        function f(dfT: number): number {
            dc.set(tenor, dfT)

            // Huecos entre prevT y T (colocado después el entry para T)
            for (let t = prevT + 1; t < tenor; t++) {
                dc.set(t, logLinearDF(t, prevT, tenor, dc))
            }

            let sumDF = 0
            for (let i = 1; i <= tenor; i++) sumDF += dc.get(i)!

            return rt * sumDF + dfT - 1
        }

        const dfGuess = Math.exp(-rt * tenor)
        const dfT = newtonSolve(f, dfGuess)
        dc.set(tenor, dfT)
    }

    // return discountCurva
    return new Map(Array.from(dc).sort((a, b) => a[0] - b[0]))
}
